import { ExternalMenuLink, ExternalMenuLinkState } from "./types";

export function getDefaultState(): ExternalMenuLinkState {
	return { externalMenuLinks: [] as ExternalMenuLink[] };
}
